import React from 'react';

import FilteredCardList from 'Site/Ui/FilteredCardList';
import ContentController from 'RLX/Controllers/ContentController';

class FilteredCardListEditor extends ContentController {
  constructor (props) {
    super(props);
  }

  static getInitialShape () {
    return {
      props: {
        list: [],
        showAllOption: null,
        filters: []
      }
    }
  }

  getClassName () {
    return 'FilteredCardListEditor';
  }

  getBlockName () {
    return 'Filterable Card List';
  }

  getPreview () {
    const { props } = this.props.content;
    return <FilteredCardList {...props} />
  }

  getFields () {
    const { content } = this.props;
    return [
      {
        type: 'text',
        label: '"Show All" Option Text',
        icon: 'list',
        value: content.props.showAllOption,
        onChange: this.applyUpdate((showAllOption, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, showAllOption }};
        })
      },
      {
        content: <hr style={{ margin: '2vh 0 5vh', opacity: 0.1, display: 'block' }} />
      },
      {
        type: 'FilteredCardList',
        icon: 'square',
        label: 'Cards',
        value: content.props.list,
        onChange: this.applyUpdate((list, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, list } };
        })
      }
    ];
  }
};

export default FilteredCardListEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/FilteredCardListEditor.jsx